export enum ComponentType {
  VIDEO = 'video',
  AUDIO = 'audio',
  IMAGE = 'image',
  BUTTON = 'button',
  POPUP = 'popup',
  FORM = 'form'
}
